import { Button, DatePicker, Input, Modal, Tabs } from "antd";
import { DollarOutlined, SaveOutlined, CloseCircleOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { startSetDatosCobro } from "../../../../context/actions/cobrosActions";
import { useSelector } from "react-redux";


const initialBody = {
  fechaFactura: null,
  fechaFacturaPagada: null,
  montoCobrado: "",
  noSeCobra: false,
  motivoNoSeCobra: "",
};

export const BotonCobros = () => {
  const { asistenciaID } = useParams();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [body, setBody] = useState(initialBody);

  const handleSubmit = () => {
    const payload = { asistenciaID };
    if (body.fechaFactura) payload.fechaFactura = body.fechaFactura.format("YYYY-MM-DD");
    if (body.fechaFacturaPagada) payload.fechaFacturaPagada = body.fechaFacturaPagada.format("YYYY-MM-DD");
    if (body.montoCobrado) payload.montoCobrado = body.montoCobrado;
    if (body.noSeCobra) {
      payload.noSeCobra = body.noSeCobra;
      payload.motivoNoSeCobra = body.motivoNoSeCobra;
    }
    dispatch(startSetDatosCobro(payload));
    setOpen(false);
  };

  const { fechaFactura, fechaFacturaPagada, noSeCobra, montoCobrado } = useSelector(
    (state) => state.detalleReducer.asistencia
  )

  const tabItems = [
    {
      key: "1",
      label: "Se cobra",
      children: (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div>
            <div className="inputLabel">Fecha Factura</div>
            <DatePicker
              style={{ width: "100%" }}
              value={body.fechaFactura}
              onChange={(val) => setBody((b) => ({ ...b, fechaFactura: val }))}
            />
          </div>
          <div>
            <div className="inputLabel">Monto Cobrado</div>
            <Input
              style={{ width: "100%" }}
              value={montoCobrado || body.montoCobrado}
              disabled={!!montoCobrado}
              onChange={(e) => setBody((b) => ({ ...b, montoCobrado: e.target.value }))}
            />
          </div>
          <div>
            <div className="inputLabel">Fecha Factura Pagada</div>
            <DatePicker
              style={{ width: "100%" }}
              value={body.fechaFacturaPagada}
              onChange={(val) => setBody((b) => ({ ...b, fechaFacturaPagada: val }))}
            />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "No se cobra",
      children: (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div>
              <div className="inputLabel">Motivo</div>
              <Input.TextArea
                rows={3}
                value={body.motivoNoSeCobra}
                onChange={(e) => setBody((b) => ({ ...b, motivoNoSeCobra: e.target.value }))}
              />
            </div>
        </div>
      ),
    },
  ];

  if((fechaFactura && fechaFacturaPagada) || noSeCobra) return null;

  const handleTabChange = (key) => {
    if (key === "2") {
      setBody((b) => ({ ...b, noSeCobra: true }));
    } else {
      setBody((b) => ({ ...b, noSeCobra: false }));
    }
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        type="dashed"
        icon={<DollarOutlined />}
      >
        Cobros
      </Button>
      <Modal
        title={<span><DollarOutlined style={{ marginRight: 8 }} />Cobros</span>}
        open={open}
        onCancel={() => setOpen(false)}
        onOk={handleSubmit}
        okText={<span><SaveOutlined style={{ marginRight: 6 }} />Guardar</span>}
        cancelText={<span><CloseCircleOutlined style={{ marginRight: 6 }} />Cancelar</span>}
        cancelButtonProps={{ danger: true, type: "primary" }}
      >
        <Tabs items={tabItems} onChange={handleTabChange} />
      </Modal>
    </>
  );
};